// src/components/questions/multipleChoiceQuestion/MultipleChoiceQuestion.jsx
import React from "react";
import "./multipleChoiceQuestion.css";

/**
 * MultipleChoiceQuestion controlado.
 * - Comportamiento original: seleccion multiple + opcion "Ninguna".
 * - Si `uniqueChoice` es true: permite una sola seleccion.
 */
const MultipleChoiceQuestion = ({
  question,
  options,
  required,
  value = [],
  updateProgress,
  uniqueChoice = false,
}) => {
  const selectedValues = Array.isArray(value) ? value : [];

  const handleChange = (option) => {
    let updatedSelection;

    if (uniqueChoice) {
      if (option === "Ninguna") {
        updatedSelection = selectedValues.includes("Ninguna") ? [] : ["Ninguna"];
      } else if (selectedValues.includes(option)) {
        updatedSelection = [];
      } else {
        updatedSelection = [option];
      }
    } else if (option === "Ninguna") {
      updatedSelection = selectedValues.includes("Ninguna") ? [] : ["Ninguna"];
    } else if (selectedValues.includes("Ninguna")) {
      updatedSelection = [option];
    } else if (selectedValues.includes(option)) {
      updatedSelection = selectedValues.filter((item) => item !== option);
    } else {
      updatedSelection = [...selectedValues, option];
    }

    updateProgress(updatedSelection.length > 0 ? updatedSelection : ["No respondida"]);
  };

  return (
    <div className="multiple-choice-question">
      <label className="question-label">
        {question} {required && <span className="required">*</span>}
      </label>
      <div className="options-container">
        {["Ninguna", ...(options || [])].map((option, idx) => (
          <label key={idx} className="checkbox-label">
            <input
              type="checkbox"
              value={option}
              checked={selectedValues.includes(option)}
              onChange={() => handleChange(option)}
            />
            {option}
          </label>
        ))}
      </div>
    </div>
  );
};

export default MultipleChoiceQuestion;
